
import React from 'react';
import { DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import ProductSelectorContent from './ProductSelectorContent';
import { Product } from '@/lib/supabase/products/types';

interface ProductSelectorDialogProps {
  loading: boolean;
  error?: string | null;
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  filteredProducts: Product[];
  selectedProduct: Product | null;
  setSelectedProduct: (product: Product) => void;
  quantity: string;
  setQuantity: (qty: string) => void;
  showCustomProduct: boolean;
  setShowCustomProduct: (show: boolean) => void;
  productName: string;
  setProductName: (name: string) => void;
  productPrice: string;
  setProductPrice: (price: string) => void;
  onAddProduct: () => void;
}

export const ProductSelectorDialog = (props: ProductSelectorDialogProps) => {
  return (
    <DialogContent className="sm:max-w-[650px]">
      <DialogHeader>
        <DialogTitle>Sélectionner un produit</DialogTitle>
      </DialogHeader>
      
      <ProductSelectorContent {...props} />
    </DialogContent>
  );
};
